export default __webpack_public_path__ + "static/media/Eye_1_M_C3.4089321e.svg";